import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';
// this list is displayed in the mobile nav menu and also

import type { MobileNavItem } from 'components/mobileNavV2/MobileNavData';
import type { MobileNavLink } from 'components/MobileNavV3/MobileNavMenu/MobileNavMenuData/MobileNavMenuData';

// in the mobile search view when 'products' is the selected tab
const getRegistryShopLinks = (
  isShopHolidaySeason: boolean,
  isMobileNavV = false
): (MobileNavItem & { path: string })[] => [
  { title: 'New Arrivals', path: '/shop/collection/new-arrivals' },
  ...insertInArrayIf(!isMobileNavV, {
    title: 'Collections',
    type: 'link',
    path: '/shop/gift-collections/style-collections',
  }),
  ...insertInArrayIf(!isMobileNavV, { title: 'Brands', path: '/shop/brands' }),
  { title: 'Kitchen', path: '/shop/category/kitchen' },
  { title: 'Tabletop', path: '/shop/category/dining' },
  { title: 'Bed & Bath', path: '/shop/category/bedding-and-bath' },
  { title: 'Furniture', path: '/shop/category/furniture' },
  { title: 'Home', path: '/shop/category/home' },
  { title: 'Weekend', path: '/shop/category/weekend' },
  ...insertInArrayIf(!isMobileNavV, { title: 'Experiences', path: '/shop/category/experiences' }),
  ...insertInArrayIf(!isMobileNavV, { title: 'Cash Funds', path: '/shop/honeymoon-cash-funds' }),
];

const mapNavItemToLink = ({ title, path }: MobileNavItem & { path: string }): MobileNavLink => ({
  title,
  path,
});

export const getMobileRegistryMenuItems = (isShopHolidaySeason: boolean): MobileNavLink[] => {
  const shopLinks = getRegistryShopLinks(isShopHolidaySeason);
  return shopLinks.map(mapNavItemToLink);
};

export default getRegistryShopLinks;
